var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-ann-table-popup",style:({
    left: `${_vm.tablePosition.x}px`,
    top: `${_vm.tablePosition.y - 22}px`,
    width: `${_vm.tablePosition.width}px`,
    height: `${_vm.tablePosition.height}px`,
    maxWidth: `${_vm.pageSize.width}px`,
    maxHeight: `${_vm.pageSize.height}px`,
  })},[_c('b-table',{ref:"table",staticClass:"full-height",attrs:{"detail-icon":"faScissors","data":_vm.rows,"columns":_vm.columns,"narrowed":true,"bordered":true,"draggable-column":""},on:{"columndragstart":_vm.columndragstart,"columndrop":_vm.columndrop,"columndragover":_vm.columndragover,"columndragleave":_vm.columndragleave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }